
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 446.895 446.895","height":"14","width":"14","fill":"#2edda7"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M223.447 446.895c-101.311 0-183.738-82.42-183.738-183.738 0-93.853 71.811-173.051 164.495-182.712V0l30.95 21.176 132.381 76.066-132.703 79.055-30.634 20.275v-77.193c-72.283 9.452-126.002 70.158-126.002 143.784 0 80.093 65.158 145.252 145.252 145.252 79.723 0 144.876-64.86 145.234-144.589V232.84h38.504l-.197 38.033c-4.076 97.587-85.202 176.022-183.542 176.022z"}})])
          )
        }
      }
    